export const AdSlotLabelHeight = 24;
